var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLeaderboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ic_Leaderboard",
    transform: "translate(-311 -105)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon_Bg",
    "data-name": "Icon Bg",
    width: 100,
    height: 100,
    transform: "translate(311 105)",
    fill: "none",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497890",
    "data-name": "Path 497890",
    d: "M10,5a5.006,5.006,0,0,0-5,5V30H30V5H10m0-5H35V35H0V10A10,10,0,0,1,10,0Z",
    transform: "translate(311 170)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497889",
    "data-name": "Path 497889",
    d: "M10,5a5.006,5.006,0,0,0-5,5V60H35V10a5.006,5.006,0,0,0-5-5H10m0-5H30A10,10,0,0,1,40,10V65H0V10A10,10,0,0,1,10,0Z",
    transform: "translate(341 140)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497888",
    "data-name": "Path 497888",
    d: "M5,5V45H30V10a5.006,5.006,0,0,0-5-5H5M0,0H25A10,10,0,0,1,35,10V50H0Z",
    transform: "translate(376 155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497886",
    "data-name": "Path 497886",
    d: "M18.625,4.07a3.245,3.245,0,0,1,3.092,2.245l1.737,5.346H29.07a3.256,3.256,0,0,1,1.92,5.884l-4.55,3.305L28.172,26.2a3.215,3.215,0,0,1-.454,2.913,3.28,3.28,0,0,1-2.642,1.354,3.22,3.22,0,0,1-1.911-.631l-4.54-3.3-4.544,3.305a3.217,3.217,0,0,1-1.907.628A3.28,3.28,0,0,1,9.533,29.11,3.216,3.216,0,0,1,9.079,26.2l1.732-5.346-4.545-3.3a3.256,3.256,0,0,1,1.915-5.887H13.8l1.737-5.345A3.245,3.245,0,0,1,18.625,4.07Zm8.152,11.592H22.911a3.244,3.244,0,0,1-3.092-2.247L18.625,9.743l-1.193,3.672a3.244,3.244,0,0,1-3.093,2.247H10.473L13.6,17.936a3.239,3.239,0,0,1,1.175,3.641l-1.188,3.668,3.118-2.268a3.26,3.26,0,0,1,3.822-.007l3.127,2.275-1.191-3.677a3.235,3.235,0,0,1,1.176-3.63Z",
    transform: "translate(342.374 101.7)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeaderboard);
export default __webpack_public_path__ + "static/media/Ic_Leaderboard.f7f107098cc8d9460e008801f47dd472.svg";
export { ForwardRef as ReactComponent };